"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SceneLoadingData {
    constructor(key, item) {
        this.key = key;
        this.item = item;
    }
    getKey() {
        if (this.key == "scene2") {
            return "scene2_" + this.item.trim();
        }
        return this.key;
    }
}
exports.SceneLoadingData = SceneLoadingData;
